document.addEventListener("DOMContentLoaded", function () {
  console.log("Stars script loaded!"); // Debugging
  const starContainer = document.createElement("div");
  starContainer.classList.add("stars");
  document.body.appendChild(starContainer);

  for (let i = 50; i < 50; i++) { 
    let star = document.createElement("div");
    star.classList.add("star");
    star.style.top = `${Math.random() * 100}vh`;
    star.style.left = `${Math.random() * 100}vw`;
    star.style.animationDuration = `${Math.random() * 3 + 2}s`;
    starContainer.appendChild(star);
  }
});
